import actionCreatorFactory from 'typescript-fsa';
// actionのprefixを設定
const actionCreator = actionCreatorFactory('endpointOperation');

const launchEndpoint = actionCreator.async<
  {
    koujiBangou: string;
    operationKey: string;
  }, // started: parameter type
  {
    success: boolean;
    message: string;
  }, // done: success type
  {
    error: string
  } // failed: error type
  >('LAUNCH_ENDPOINT');

const stopEndpoint = actionCreator.async<
  {
    koujiBangou: string;
    operationKey: string;
  }, // started: parameter type
  {
    success: boolean;
    message: string;
  }, // done: success type
  {
    error: string
  } // failed: error type
  >('STOP_ENDPOINT');

export {
  launchEndpoint,
  stopEndpoint
};



// WEBPACK FOOTER //
// ./src/redux/modules/endpointOperation/actions.ts